module.exports = __webpack_public_path__ + "static/img/thirdCard.aefd846.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/thirdCard.png
// module id = ugjN
// module chunks = 0